<template>
  <join-challenge-percent-based v-if="isPercentBasedChallenge" />
  <join-challenge-personal-goal v-else-if="isPersonalValueBasedChallenge" />
  <join-challenge-value-based v-else />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useChallengeStore } from '../../stores/challenge';
import JoinChallengePercentBased from './JoinChallengePercentBased.vue';
import JoinChallengePersonalGoal from './JoinChallengePersonalGoal.vue';
import JoinChallengeValueBased from './JoinChallengeValueBased.vue';
import useTrackDashboardVisit from '../../composables/useTrackDashboardVisit';

const challengeStore = useChallengeStore();
const {
  isPercentBasedChallenge,
  isPersonalValueBasedChallenge,
} = storeToRefs(challengeStore);

const { markJoinChallengeVisited } = useTrackDashboardVisit();
markJoinChallengeVisited();
</script>
